// extracted by mini-css-extract-plugin
export default {"preview":"paymentPreviewModal_preview__dXDXj","cta":"paymentPreviewModal_cta__UVjHJ","greyBtn":"paymentPreviewModal_greyBtn__eENoj"};